import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";
import { resolvePublicAppUrl } from "../lib/url/public-app-url.mjs";

export const getEnvSchema = () => ({
    server: {
        NODE_ENV: z.enum(["development", "test", "production"]).default("development"),
        CLERK_SECRET_KEY: z.string(),
        CLERK_AUTHORIZED_PARTIES: z.string().optional(),
        STRIPE_PUBLISHABLE_KEY: z.string().default(""),
        SELFHOST_API_ORIGIN: z.string().url().optional(),
        SELFHOST_API_REWRITE_ENABLED: z.enum(["false", "true"]).default("false"),
    },
    client: {
        NEXT_PUBLIC_URI: z.string(),
        NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY: z.string(),
        NEXT_PUBLIC_SYNC_FUSION_LICENSE: z.string(),
        NEXT_PUBLIC_PUSHER_APP_ID: z.string(),
        NEXT_PUBLIC_PUSHER_KEY: z.string(),
        NEXT_PUBLIC_PUSHER_CLUSTER: z.string(),
        NEXT_PUBLIC_SYNC_FUSION_SERVICE_URL: z.string(),
        NEXT_PUBLIC_GLOBAL_ADMINS: z.string().optional(),
        NEXT_PUBLIC_PYTHON_API_BASE_URI: z.string(),
    },
    runtimeEnv: {
        NODE_ENV: process.env.NODE_ENV,
        CLERK_SECRET_KEY: process.env.CLERK_SECRET_KEY,
        CLERK_AUTHORIZED_PARTIES: process.env.CLERK_AUTHORIZED_PARTIES,
        STRIPE_PUBLISHABLE_KEY: process.env.STRIPE_PUBLISHABLE_KEY ?? "",
        SELFHOST_API_ORIGIN: process.env.SELFHOST_API_ORIGIN,
        SELFHOST_API_REWRITE_ENABLED: process.env.SELFHOST_API_REWRITE_ENABLED,
        NEXT_PUBLIC_URI: resolvePublicAppUrl({
            explicitPublicUri: process.env.NEXT_PUBLIC_URI,
            vercelUrl: process.env.NEXT_PUBLIC_VERCEL_URL,
        }),
        NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY: process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY,
        NEXT_PUBLIC_SYNC_FUSION_LICENSE: process.env.NEXT_PUBLIC_SYNC_FUSION_LICENSE,
        NEXT_PUBLIC_PUSHER_APP_ID: process.env.NEXT_PUBLIC_PUSHER_APP_ID,
        NEXT_PUBLIC_PUSHER_KEY: process.env.NEXT_PUBLIC_PUSHER_KEY,
        NEXT_PUBLIC_PUSHER_CLUSTER: process.env.NEXT_PUBLIC_PUSHER_CLUSTER,
        NEXT_PUBLIC_SYNC_FUSION_SERVICE_URL: process.env.NEXT_PUBLIC_SYNC_FUSION_SERVICE_URL,
        NEXT_PUBLIC_GLOBAL_ADMINS: process.env.NEXT_PUBLIC_GLOBAL_ADMINS,
        NEXT_PUBLIC_PYTHON_API_BASE_URI: process.env.NEXT_PUBLIC_PYTHON_API_BASE_URI,
    },
    skipValidation:
        !!process.env.SKIP_ENV_VALIDATION ||
        process.env.VERCEL === "1" ||
        process.env.VERCEL_ENV === "production" ||
        process.env.VERCEL_ENV === "preview",
    emptyStringAsUndefined: true,
});
export const env = createEnv(getEnvSchema());
export { createEnv };
